<template lang="pug">
.container.cardVisualizar
    .card
      .card-body
        informacoes-conversa(
          :idConversa="idConversa",
          :voltar="'central/comunicacao'",
          @statusChanged="setStatus"
        )
        el-row.footer-buttons(v-if="statusConversa && statusConversa === 'RESPONDIDA'")
          .responder
            el-button.btn-conversa(
              type="primary"
              @click="responder()"
              )
              i.fal.fa-reply
              |&emsp;Responder
          .finalizar-conversa
            el-button.btn-conversa(
              type="primary"
              @click="finalizar()"
              )
              i.fal.fa-check
              |&emsp;Finalizar conversa
    el-row.voltar-container
      app-buttons-cadastro(
        :isPrimeiroPasso="false",
        :isUltimoPasso="true",
        :showButtonFinalizar="false"
        :showButtonEnviar="false"
        :showButtonCancelar="false"
        @voltar="voltar"
      )
</template>

<script>
import InformacoesConversa from '@/screens/central/components/comunicacao/InformacoesConversa'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppButtonsCadastro from '@/components/AppButtonsCadastro'

import { mapActions } from 'vuex'

export default {
  mixins: [
    AppNotificacao
  ],
  components: {
    InformacoesConversa,
    AppButtonsCadastro
  },
  data () {
    return {
      idConversa: this.$route.params.idConversa,
      statusConversa: null
    }
  },
  methods: {
    ...mapActions({
      encerrarConversa: 'conversa/encerrarConversa'
    }),

    responder () {
      this.$router.push({
        name: 'conversas/new',
        params: { idConversa: this.idConversa }
      })
    },

    setStatus (status) {
      this.statusConversa = status
    },

    finalizar () {
      this.confirmBox('Tem certeza que deseja finalizar essa conversa? Após finalizada, esta conversa não poderá ser reaberta.', this.$messages.TITULO_WARNING,
        async () => {
          const payloadMensagem = {
            assunto: null,
            tipo: 'OUVIDORIA',
            mensagemList: [],
            id: this.idConversa ? this.idConversa : null
          }

          await this.encerrarConversa(payloadMensagem)

          this.$router.push({
            name: 'central/comunicacao'
          })
        },
        () => {
        }, 'Concluir', 'Cancelar')
    },

    voltar () {
      this.$router.push({
        name: 'central/comunicacao'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  flex-direction: column;
}
.footer-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
}
.voltar-container {
  padding: 0px 20px 30px 20px;
}
.responder {
  margin-right: 5px;
}
.finalizar-conversa {
  margin-left: 5px;
}

@media (max-width: 780px) {
  .card {
    position: relative;
    left: 20px;
    width: 315px;
  }

  .container {
    position: relative;
    top: 35px;
  }

  .cardVisualizar {
    top: 60px;
    right: 65%;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/central/comunicacao/VisualizarConversa.vue